import React from 'react'
import { Link } from 'react-router-dom'

function OTPPage() {
  return (
    <div className="grid place-items-center max-w-7xl mx-auto w-[90%] min-h-[80vh] px-4 py-16">
        <div className="max-w-2xl w-full">
          <div>
            <h1 className="text-[2rem] font-medium text-center text-w-heading mt-4">
              OTP
            </h1>
          </div>
          <form action="" className="w-full max-w-sm mx-auto">
            <div className="flex mt-5 w-full border rounded">
              <input
                className="h-9 px-2 w-full"
                type='text'
                placeholder="Phone Number"
              />
            </div>
            <div className="flex mt-5 w-full border rounded">
              <input
                className="h-9 px-2 w-full"
                type='text'
                placeholder="Otp"
              />
            </div>
            <div className="w-full mt-8 flex">
              <Link to={"/dashboard"} className="bg-w-btn text-w-btn-text max-w-[6rem] w-full px-2 py-1 rounded mx-auto text-center">
                Submit
              </Link>
            </div>
          </form>
          <div className="mt-24 w-full">
            <p className="text-center text-sm font-medium">
              Resend 
              <Link to={"/signup"} className="text-w-bg hover:underline ml-1">
                OTP
              </Link>
            </p>
          </div>
        </div>
      </div>
  )
}

export default OTPPage